const Plans = [
    {
        title: 'Basic',
        price: 79,
        features: ['unlimited build minutes', 'Lorem, ipsum dolor.', '5TB Lorem, ipsum dolor.'],
        isPopular: false
    },
    {
        title: 'Plus +',
        price: 149,
        features: [
            'unlimited build minutes',
            'Lorem, ipsum dolor.',
            '5TB Lorem, ipsum dolor.',
            '5TB Lorem, ipsum dolor.',
            '5TB Lorem, ipsum dolor.',
        ],
        isPopular: true
    },
    {
        title: 'Combo',
        price: 349,
        features: ['unlimited build minutes', 'Lorem, ipsum dolor.', '5TB Lorem, ipsum dolor.'],
        isPopular: false
    },
];

export default Plans